import * as actionTypes from 'modules/audits/actionTypes';
import type { PayloadAction } from 'modules/global/generic.types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import type { AuditWithEvents } from './utils';
import { isAuditWithEvents } from './utils';

export type AuditEventIdsByAuditId = Record<string, string[]>;

export const initialState: AuditEventIdsByAuditId = {};

const removeAudit = (
  state: AuditEventIdsByAuditId,
  { payload: auditId }: PayloadAction<string>,
): AuditEventIdsByAuditId => {
  const { [auditId]: _removed, ...rest } = state;
  return rest;
};

const reset = (): AuditEventIdsByAuditId => initialState;

export default createReducer(
  initialState,
  {
    [actionTypes.DELETE_SUCCESS]: removeAudit,
    [LOCATION_CHANGE]: reset,
  },
  [
    {
      matcher: isAuditWithEvents,
      reducer: (state, { payload }: PayloadAction<AuditWithEvents>) => ({
        ...state,
        [payload.id]: payload.events.map(({ id }) => id as string),
      }),
    },
  ],
);
